import React, { useEffect, useState, useRef } from "react";
import { w3cwebsocket as W3CWebSocket } from "websocket";
import { Tag, Position, OverlayToaster } from "@blueprintjs/core";
import { Trans } from "react-i18next";

import dindong from "../../../../src/UX/sounds/UI_Quirky_46.mp3";
import { getBackendRoute } from "../../../utils/AuthenticatedFetch";

export function NotifALPR(props) {
  const [recoCount, setRecoCount] = useState(0);
  const AppToaster = useRef(null);

  useEffect(() => {
    const client = new W3CWebSocket(
      getBackendRoute("WS") + "/supervision/alpr/reconciliations?notif=true",
      ["Bearer", localStorage.getItem("token")]
    );
    client.onmessage = (message) => {
      try {
        const data = JSON.parse(message.data);
        if (data.reconciliation !== undefined && data.count > recoCount) {
          AppToaster.current.show({
            message: (
              <a href="/alpr">
                <div>
                  <Trans>new reconciliation, click here to solve</Trans>
                  <div className="flexbox-center-center">
                    <img
                      style={{ height: "100px" }}
                      alt="vehicule at entry"
                      src={data.reconciliation.entryImage.base64}
                    />
                    <img
                      style={{ height: "100px" }}
                      alt="vehicule at exit"
                      src={data.reconciliation.exitImage.base64}
                    />
                  </div>
                </div>
              </a>
            ),
            intent: "warning",
            icon: "unknown-vehicle",
          });
          const audio = new Audio(dindong);
          // audio must be the last stuff to do of the try, cause if the page is not focused,
          // playing sound is not allowed
          // "The play method is not allowed by the user agent or the platform in the current context, possibly because the user denied permission."
          audio.play();
        }
        if (data.count !== undefined) setRecoCount(data.count);
      } catch (e) {
        console.error(e);
        console.error(
          "Error while parsing reconciliation" + JSON.stringify(message)
        );
      }
    };
    return () => {
      if (client !== undefined) client.close();
    };
  }, [recoCount]);

  return (
    <span>
      <OverlayToaster
        ref={AppToaster}
        position={Position.BOTTOM_LEFT}
        maxToasts={3}
      />
      {recoCount > 0 && <Tag intent="danger">{recoCount}</Tag>}
    </span>
  );
}
